module.exports = __webpack_public_path__ + "static/media/ringtone.7950a5e9.mp3";